import { render, staticRenderFns } from "./PRJ401M01.vue?vue&type=template&id=940a0cd6&"
import script from "./PRJ401M01.vue?vue&type=script&lang=js&"
export * from "./PRJ401M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports